import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
})
export class IncludesPipe implements PipeTransform {
  transform(list: any[], value: any): boolean {
    return list != null && list.includes(value);
  }
}
